/**
 * css class setting
 */
export default {
    root: 'bear-react-carousel__root',
    content: 'bear-react-carousel__content',
    container: 'bear-react-carousel__container',
    containerInit: 'bear-react-carousel__container-init',
    slideItem: 'bear-react-carousel__slide-item',
    slideItemImg: 'bear-react-carousel__slide-item__img',
    slideItemDiv: 'bear-react-carousel__slide-item__div',
    navGroup: 'bear-react-carousel__nav-group',
    navPrevButton: 'bear-react-carousel__nav-prev-button',
    navNextButton: 'bear-react-carousel__nav-next-button',
    navIcon: 'bear-react-carousel__nav-icon',
    paginationGroup: 'bear-react-carousel__pagination-group',
    paginationButton: 'bear-react-carousel__pagination-button',
    paginationContent: 'bear-react-carousel__pagination-content',

    testNumber: 'bear-react-carousel__test-number',
    testWindowSize: 'bear-react-carousel__window-size',
    cloneIconGroup: 'bear-react-carousel__clone-icon-group',
    cloneIcon: 'bear-react-carousel__clone-icon',
};
